import { createApp } from "vue";
import PrimeVue from "primevue/config";
import { createPinia } from "pinia";
import booking from "./Booking.vue";
import router from "./router";
import TJButton from "@components/TJButton.vue";
import Box from "@templates/Box.vue";
import { useBookingStore } from "@stores/BookingStore"; // Import the store
import { useDashboardStore } from "@stores/DashboardStore"; // Import the new dashboard store
import VueMobileDetection from "vue-mobile-detection";
import ToastService from "primevue/toastservice";

const app = createApp(booking);

// global components
app.component("TJButton", TJButton);
app.component("Btn", TJButton);
app.component("Box", Box);

const pinia = createPinia(); // Create Pinia instance

app.use(VueMobileDetection);
app.use(pinia); // Use the created Pinia instance
app.use(router);
app.use(PrimeVue);
app.use(ToastService);

// Initialize stores and load from localStorage after Pinia is used
const bookingStore = useBookingStore(); // This instantiates the store
bookingStore.loadBookingFromLocalStorage();
bookingStore.loadClinicFromLocalStorage();

// const dashboardStore = useDashboardStore(); // Instantiate if you need to call actions on app load
app.mount("#booking");
